import { useState } from "react";
import { Input } from "../../../../components/Input";
import { Button, Content, Field, Label } from "../../../../components/Forms";
import { Textarea } from "../../../../components/Textarea";

export function Form() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  return (
    <Content customWidth="calc(46% - 12px)">
      <Label>Nome</Label>
      <Field marginBottom="16px">
        <Input
          type="text"
          placeholder=""
          value={name}
          onChange={(value) => setName(value)}
        />
      </Field>
      <Label>Email</Label>
      <Field marginBottom="16px">
        <Input
          type="email"
          placeholder=""
          value={email}
          onChange={(value) => setEmail(value)}
        />
      </Field>
      <Label>Mensagem</Label>
      <Field marginBottom="16px">
        <Textarea
          type="email"
          placeholder=""
          value={message}
          onChange={(value) => setMessage(value)}
        />
      </Field>
      <Button>Enviar</Button>
    </Content>
  );
}